import { cn } from "@/lib/utils";

type PageContentSkeletonProps = {
	className?: string;
	variant?: "blocks" | "compact";
};

const blockClass = "w-full rounded-xl bg-gray-200 min-h-[5rem]";

export function PageContentSkeleton({
	className,
	variant = "blocks",
}: PageContentSkeletonProps) {
	if (variant === "compact") {
		return (
			<div
				className={cn(
					"h-8 max-w-40 animate-pulse rounded-xl bg-gray-200 motion-reduce:animate-none motion-reduce:opacity-80",
					className,
				)}
				aria-hidden
			/>
		);
	}

	return (
		<div
			className={cn(
				"w-full! animate-pulse space-y-4 motion-reduce:animate-none motion-reduce:opacity-80",
				className,
			)}
			aria-busy
		>
			<div className={cn(blockClass, "min-h-32")} />
			<div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
				<div className={blockClass} />
				<div className={blockClass} />
				<div className={blockClass} />
			</div>
			<div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
				<div className={blockClass} />
				<div className={blockClass} />
			</div>
		</div>
	);
}
